import React from 'react';
import './loginFooter.css';

export default function LoginFooter() {
  return (
    <div className="footer-container">
    <footer className='container'>
      <div className="footer-logo">       
      </div>
      <div className="footer-content">
        <div className="footer-links">
          <a href="http://www.fmcsa.dot.gov/feedback.htm" className="footer_link">Feedback</a>
          <span className="footer_white_text">|</span> 
          <a href="http://www.fmcsa.dot.gov/Online-Privacy-Policy.aspx" className="footer_link">Privacy Policy</a>
          <span className="footer_white_text">|</span> 
          <a href="http://www.usa.gov/" className="footer_link">USA.gov</a> 
          <span className="footer_white_text">|</span> 
          <a href="http://www.fmcsa.dot.gov/foia/foia.htm" className="footer_link">Freedom of Information Act (FOIA)</a>
          <span className="footer_white_text">|</span> 
          <a href="http://www.fmcsa.dot.gov/508disclaimer.htm" className="footer_link">Accessibility</a> 
          <span className="footer_white_text">|</span> 
          <a href="http://www.oig.dot.gov/Hotline" className="footer_link">OIG Hotline</a> 
          <span className="footer_white_text">|</span> 
          <a href="http://www.fmcsa.dot.gov/about/WebPoliciesAndImportantLinks.htm" className="footer_link">Web Policies and Important Links</a> 
          <span className="footer_white_text">|</span> 
          <a href="http://www.fmcsa.dot.gov/sitemap.aspx" className="footer_link">Site Map</a>
          <span className="footer_white_text">|</span> 
          <a href="http://www.fmcsa.dot.gov/plugins.htm" className="footer_link">Plug-ins</a>
        </div>
        <div className="footer-text">
          <p>
            <span className="footer_title_text">Federal Motor Carrier Safety Administration</span><br />
            <span className="footer_white_text">1200 New Jersey Avenue SE, Washington, DC 20590 &#8226;
            1-800-832-5660 &#8226; TTY: 1-800-877-8339 &#8226; </span>
            <a href="http://www.fmcsa.dot.gov/about/contact/offices/displayfieldroster.asp" className="footer_link">Field Office Contacts</a>
          
            
         
          </p>
        </div>
      </div>
    </footer>
    </div>
  );
}
